export default __webpack_public_path__ + "static/media/LoginM.9cfc8a80.jpg";